import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import NewsList from "@/pages/news/page";
import NewsDetail from "@/pages/news/detail/page";
import WorksList from "@/pages/works/page";
import WorkDetail from "@/pages/works/detail/page";
import ProfilePage from "@/pages/profile/page";
import SearchPage from "@/pages/search/page";
import AboutPage from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "news", element: <NewsList /> },
      { path: "news/:id", element: <NewsDetail /> },
      { path: "works", element: <WorksList /> },
      { path: "works/:id", element: <WorkDetail /> },
      { path: "profile", element: <ProfilePage /> },
      { path: "search", element: <SearchPage /> },
      { path: "about", element: <AboutPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;